import React from "react";
import {DefaultDataGridState} from "../Types/DefaultDataGridState";
import {get} from "../../../../../utils/dotutils";
import {GUIProps} from "./Types/GUIProps";
import FieldData from "./FieldData";

export class Footer extends React.Component<GUIProps, DefaultDataGridState> {
    render() {
        return (
            <tfoot className="p-datatable-tfoot">
            {!!this.props.data?.items?.length && (this.props.data.aggregations || []).map((item, rowIdx) => {
                return <tr key={rowIdx}>
                    {this.props.getFields({onlyVisible: true}).map((child, columnIdx) => {
                        const FieldType = child.type || FieldData;
                        return <FieldType
                            isEditing={false}
                            key={String(rowIdx) + "-" + String(columnIdx)}
                            {...this.props}
                            rowIndex={(this.props.data.navigation.rangestart || 1) + rowIdx}
                            columnIndex={columnIdx}
                            {...child.props}
                            editor={this.props.editor}
                            data={this.props.data}
                            row={item}
                            value={get(item, child.props.field)}
                            isAggregation={true}
                        />
                    })}
                </tr>
            })}
            </tfoot>
        );
    }
}